/**
 * Состояние строки «Проверка обновлений» на BootScreen.
 * Живёт вне React: main.tsx обновляет до монтирования провайдеров; UI подписывается через useSyncExternalStore.
 */

export type PwaBootUpdatePhase = "checking" | "current" | "deploying" | "completed" | "skipped";

export type PwaBootUpdateUi = {
  phase: PwaBootUpdatePhase;
  /** Правая колонка (статус / деталь). */
  detail: string;
};

const listeners = new Set<() => void>();

let state: PwaBootUpdateUi = {
  phase: "checking",
  detail: "ожидание ответа репозитория",
};

function emit() {
  for (const l of listeners) {
    l();
  }
}

export function getPwaBootUpdateSnapshot(): PwaBootUpdateUi {
  return state;
}

export function subscribePwaBootUpdate(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function setPwaBootUpdate(
  next: PwaBootUpdateUi | ((prev: PwaBootUpdateUi) => PwaBootUpdateUi),
): void {
  state = typeof next === "function" ? next(state) : next;
  emit();
}
